import React from "react";
import { array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import FooterMenuGroup from "../../../molecules/FooterMenuGroup";
import Instagram from "../../../atoms/icons/Instagram";
import FacebookIcon from "../FooterIcons/FacebookIcon";
import TwitterIcon from "../FooterIcons/TwitterIcon";
import YoutubeIcon from "../FooterIcons/YoutubeIcon";
import { logoRenderer } from "../../../utils/react-utils";
import MobileLogo from "../../../atoms/MobileLogo";

import { getSocialLinks } from "../../../utils/utils";

import "./bigganChintaFooter.m.css";

const BigganChintaFooterBase = ({ bigganChintaMenuItems, currentPath }) => {
  const menuItems = bigganChintaMenuItems.find(item => item.title === "footer");
  const socialLinks = getSocialLinks("biggan-chinta");

  return (
    <div styleName="wrapper">
      {logoRenderer(<MobileLogo />, currentPath)}
      <div styleName="menu-items-wrapper">
        {menuItems && menuItems.children && menuItems.children.length > 0 && (
          <FooterMenuGroup links={menuItems.children.slice(0, 20)} />
        )}
      </div>
      <div>
        <div styleName="social-share-wrapper">
          <Link href={socialLinks.fbUrl}>
            <FacebookIcon />
          </Link>
          <Link href={socialLinks.twitterUrl}>
            <TwitterIcon />
          </Link>
          <Link href={socialLinks.InstagramUrl}>
            <Instagram />
          </Link>
          <Link href={socialLinks.YouTubeUrl}>
            <YoutubeIcon />
          </Link>
        </div>
        <ul styleName="static-data">
          <li>প্রগতি ইনস্যুরেন্স ভবন</li>
          <li>২০-২১ কারওয়ান বাজার, ঢাকা - ১২১৫</li>
          <li>ফোন: ৮১১০০৮১, ৮১১৫৩০৭-১০</li>
          <li>ইমেইল: editor.bigganchinta@prothomalo.com</li>
          <li styleName="copyrights">© স্বত্ব বিজ্ঞানচিন্তা ২০১৯</li>
        </ul>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    bigganChintaMenuItems: get(state, ["qt", "data", "navigationMenu", "bigganChintaMenuItems"], []),
    currentPath: get(state, ["currentPathReducer", "currentPath"], null)
  };
}

BigganChintaFooterBase.propTypes = {
  bigganChintaMenuItems: array,
  currentPath: string
};

export const BigganChintaFooter = connect(mapStateToProps)(BigganChintaFooterBase);
